/**
 * Mixin for recurring scope dialogs (edit/delete)
 * Provides shared logic for scope selection dialogs
 */
export default {
    data() {
        return {
            selectedScope: 'this',
            resolve: null
        };
    },
    methods: {
        /**
         * Open the dialog and return a promise that resolves with the selected scope
         *
         * @returns {Promise<string|null>} 'this', 'this_and_following', or null if cancelled
         */
        open() {
            return new Promise((resolve) => {
                this.resolve = resolve;
                this.selectedScope = 'this';
                this.$refs.dialog.show();
            });
        },

        confirm() {
            this.close(this.selectedScope);
        },

        cancel() {
            this.close(null);
        },

        close(value) {
            this.$refs.dialog.close();

            if (!this.resolve) {
                return;
            }

            this.resolve(value);
            this.resolve = null;
        }
    }
};
